@use "sass:string";
@use "../../styles/breakpoint.module.scss" as *;

.card {
    grid-column: span 4;
    margin: 0;
    // needed to prevent VideoPlayerControls from stretching height too far
    align-self: start;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

// Modal + link cards are clickable across their whole surface; a video owns
// its own clicks, so opt out when one is present.
.clickable:not(:has(video)) {
    cursor: pointer;
}

.media {
    img,
    video {
        width: 100%;
        height: auto;
        aspect-ratio: 4 / 3;
        object-fit: cover;
        display: block;
    }
}

.caption {
    display: flex;
    flex-direction: column;
    gap: var(--spacer-4);
    padding-top: var(--spacer-16);
    text-align: left;
}

.title {
    font: var(--font-h-24);
}

.subtitle {
    font: var(--font-p-16);
}

:export {
    sizes: string.unquote("(min-width: #{$mobile}) 33vw, 100vw");
}
